// Value the list routes read as "no perimeter" (none also matches an archived one).
export const NO_PERIMETER_FILTER = "none";

const PERIMETER_FILTER_ERROR_KEYS = {
    PERIMETER_FILTER_INVALID: "perimeters.listFilter.errors.invalid",
    PERIMETER_FORBIDDEN: "perimeters.listFilter.errors.forbidden",
    PERIMETER_NOT_FOUND: "perimeters.listFilter.errors.notFound",
};

// Menu entries in display order: the perimeters, then "No perimeter" if offered.
export const getPerimeterFilterChoices = (options) => {
    if (!options || !Array.isArray(options.perimeters)) return [];
    const choices = options.perimeters.map((perimeter) => ({
        value: perimeter.id,
        name: perimeter.name,
    }));
    if (options.allowNone) {
        choices.push({ value: NO_PERIMETER_FILTER, name: null });
    }
    return choices;
};

// A member restricted to a single perimeter only ever sees that one: nothing to filter.
export const isPerimeterFilterShown = (options) =>
    Boolean(options) &&
    options.hidden === false &&
    Array.isArray(options.perimeters) &&
    !(options.restricted && options.perimeters.length <= 1) &&
    getPerimeterFilterChoices(options).length > 0;

export const isPerimeterColumnShown = (options) =>
    options?.hasPerimeters === true;

// Message key for a refusal of the perimeter filter, or null for any other error.
export const getPerimeterFilterErrorKey = (err) =>
    PERIMETER_FILTER_ERROR_KEYS[err?.response?.data?.errorCode] || null;
